import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Ako imate CSS fajl, inače možete izostaviti ovu liniju
import App from './App'; // Ovo je glavna komponenta vaše aplikacije

const root = ReactDOM.createRoot(document.getElementById('root')); // Ensure the ID matches your HTML
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
